import React, { useCallback, useContext, useEffect, useState } from "react";
import ImageInput from "./ImageInput";
import { CreateArtifactContext } from "../../../context/CreateArtifactContext";
import { ContentState, ContentSubstate, SKPhotoArtifact } from "../../../models/SKArtifact";
import { useNavigationBar } from "../../../context/NavigationContext";
import { useAuth } from "../../../context/AuthContext";
import { isEditable } from "@testing-library/user-event/dist/utils";
import { useNavigate } from "react-router-dom";
import { FolderName } from "../../../api/shared/uploadService";

interface ImageUploadProps {
  maxImages?: number;
}

const CreatePhoto: React.FC<ImageUploadProps> = ({ maxImages = 3 }) => {
  const { contentData, artifactId, updateContentData, isContentEditing, isEditable } = useContext(CreateArtifactContext);
  const [photoData, setPhotoData] = useState<SKPhotoArtifact | undefined>(undefined);
  const [photoURLs, setPhotoURLs] = useState<(string | null)[]>(Array(maxImages).fill(null));
  const { setNavProps } = useNavigationBar();
  const [editable, setEditable] = useState<boolean>(true);

  const authContext = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    if (
      (contentData.status === ContentState.DRAFT ||
        (isContentEditing && contentData.status === ContentState.ACTIVE && contentData.subStatus === ContentSubstate.EDIT_IN_DRAFT)) &&
      contentData.channelId === authContext?.myChannel?.id
    ) {
      setEditable(true);
    } else {
      setEditable(false);
    }
  }, [contentData, authContext]);

  const submit = () => {
    let urls = photoURLs.filter(item => item !== null);
    updateContentData({ photoURLs: urls });
    window.history.back();
  };

  useEffect(() => {
    setNavProps(prev => ({
      ...prev,
      backArrow: false,
      buttonTitle: "Done",
      title: "Add Photo",
      filterOption: false,
      enableLink: contentData.status === ContentState.IN_REVIEW ? false : photoURLs.filter(item => item != null).length > 0 ? true : false,
      getActionItems: undefined,
      onNext: isEditable ? submit : undefined,
      onClose: () => navigate(-1),
      onEdit: undefined,
    }));
  }, [setNavProps, photoURLs, isEditable]);

  useEffect(() => {
    setPhotoData(contentData as SKPhotoArtifact);
  }, [contentData]);

  useEffect(() => {
    if (photoData?.photoURLs === undefined) return;

    const imgUrls = [...photoURLs];
    photoData?.photoURLs.map((item, index) => {
      return (imgUrls[index] = item);
    });
    setPhotoURLs(imgUrls);
  }, [photoData]);

  const handleFileChange = useCallback((index: number, fileUrl: string | null) => {
    console.log(`Upload successful for index ${index} File URL: ${fileUrl}`);
    setPhotoURLs(prevPhotoURLs => {
      const updatedPhotoURLs = [...prevPhotoURLs];
      updatedPhotoURLs[index] = fileUrl;
      return updatedPhotoURLs;
    });
  }, []);

  return (
    <div className="flex flex-col mt-[12px]">
      <div className="flex flex-col">
        <div className="flex items-center">
          <span>
            <span className="content_count">1</span>
          </span>
          <span className="content_title">Add Photo</span>
        </div>
        <div className="notes-class-content">
          Maximum {maxImages} photos allowed. Use Stories to upload more than {maxImages} photos. Recommended aspect ratio of photos are either 4:3,
          1:1 or 3:4.
        </div>
      </div>
      <div className="grid grid-cols-3 max-w-[480px] gap-x-[15px]">
        {/* {images.map((_, index) => ( */}

        {(isEditable || photoURLs[0]) && (
          <ImageInput
            key={0}
            index={0}
            onFileChange={handleFileChange}
            docId={artifactId!}
            imageWidth={150}
            imageHeight={220}
            maxFileSize={10}
            imageUrl={photoURLs[0] ?? ""}
            editable={isEditable}
            folder={FolderName.content}
          />
        )}

        {(isEditable || photoURLs[1]) && (
          <ImageInput
            key={1}
            index={1}
            onFileChange={handleFileChange}
            docId={artifactId!}
            imageWidth={150}
            imageHeight={220}
            maxFileSize={10}
            imageUrl={photoURLs[1] ?? ""}
            editable={isEditable}
            folder={FolderName.content}
          />
        )}
        {(isEditable || photoURLs[2]) && (
          <ImageInput
            key={2}
            index={2}
            onFileChange={handleFileChange}
            docId={artifactId!}
            imageWidth={150}
            imageHeight={220}
            maxFileSize={10}
            imageUrl={photoURLs[2] ?? ""}
            editable={isEditable}
            folder={FolderName.content}
          />
        )}
      </div>
    </div>
  );
};

export default CreatePhoto;
